const buildHeader = () => 
{
    var header = {
        //Authorization: 'Bearer ' + token,
        'Content-Type': 'application/json'
    };
    
    return header;
};

export default {
    get: (onResponse, url) => 
    {
        //console.log("API get", onResponse, url, token);
        
        send(onResponse, null, 'GET', url);
    },
    post: (onResponse, payload, url) => 
    {
        // console.log("API post", onResponse, payload, url, token);
        
        send(onResponse, payload, 'POST', url);
    },
    put: (onResponse, payload, url) => 
    {
        //console.log("API put", onResponse, payload, url, token);
        
        send(onResponse, payload, 'PUT', url);
    },
    delete: (onResponse, url) => 
    {
        //console.log("API delete", onResponse, url, token);
        
        send(onResponse, null, 'DELETE', url);
    }
};

async function send(onResponse, payload, requestType, url) 
{
    let response = '';
    let headers = buildHeader();
    
    //console.log('payload', JSON.stringify(payload));

    response = await fetch(url, 
    {
        method: requestType,
        headers: headers,
        body: payload ? JSON.stringify(payload) : null
    });

    if (response.ok)
    {
        //console.log("response.success", response);
        
        const text = await response.text();
        
        if (_.isEmpty(text))
        {
            onResponse.success(null);
        }
        else
        {
            onResponse.success(JSON.parse(text));
        }
    }
    else
    {
        //console.log("response.error", response);

        switch (response.status)
        {
            default: 

                onResponse.error(response);
        }
    }
}



// WEBPACK FOOTER //
// ./resources/js/components/Helpers/API.js